export const fontsToLoad = [
  `@font-face {
      font-family: Zen;
      font-weight: 300;
      src: url("https://cdn.izettle.com/fonts/zen/Zen-Light.woff2") format("woff2"),
         url("https://cdn.izettle.com/fonts/zen/Zen-Light.woff") format("woff");
  }`,
  `@font-face {
      font-family: Zen;
      font-weight: 400;
      src: url("https://cdn.izettle.com/fonts/zen/Zen-Screen.woff2") format("woff2"),
         url("https://cdn.izettle.com/fonts/zen/Zen-Screen.woff") format("woff");
  }`,
  `@font-face {
      font-family: Zen;
      font-weight: 500;
      src: url("https://cdn.izettle.com/fonts/zen/Zen-Medium.woff2") format("woff2"),
         url("https://cdn.izettle.com/fonts/zen/Zen-Medium.woff") format("woff");
    }`,
  `@font-face {
      font-family: Zen;
      font-weight: 600;
      src: url("https://cdn.izettle.com/fonts/zen/Zen-SemiBold.woff2") format("woff2"),
         url("https://cdn.izettle.com/fonts/zen/Zen-SemiBold.woff") format("woff");
  }`,
].join("\n")
